var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCloseStroke = function SvgCloseStroke(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.772705 6C0.772705 2.96243 3.23514 0.5 6.27271 0.5C9.31027 0.5 11.7727 2.96243 11.7727 6C11.7727 9.03757 9.31027 11.5 6.27271 11.5C3.23514 11.5 0.772705 9.03757 0.772705 6ZM6.27271 1.5C3.78742 1.5 1.77271 3.51472 1.77271 6C1.77271 8.48528 3.78742 10.5 6.27271 10.5C8.75799 10.5 10.7727 8.48528 10.7727 6C10.7727 3.51472 8.75799 1.5 6.27271 1.5Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.91915 3.64645C4.11441 3.45118 4.431 3.45118 4.62626 3.64645L8.62626 7.64645C8.82152 7.84171 8.82152 8.15829 8.62626 8.35355C8.431 8.54882 8.11441 8.54882 7.91915 8.35355L3.91915 4.35355C3.72389 4.15829 3.72389 3.84171 3.91915 3.64645Z",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62626 3.64645C8.431 3.45118 8.11441 3.45118 7.91915 3.64645L3.91915 7.64645C3.72389 7.84171 3.72389 8.15829 3.91915 8.35355C4.11441 8.54882 4.431 8.54882 4.62626 8.35355L8.62626 4.35355C8.82152 4.15829 8.82152 3.84171 8.62626 3.64645Z",
    fill: "#EA4335"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseStroke, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-stroke.4b6ac366.svg";
export { ForwardRef as ReactComponent };